import { escapeHtml } from './html.js?v=6.87.12';

export class NoticeCenter {
  constructor(root) { this.root = root; this.timer = null; }
  show(message, type = 'notice') {
    if (!this.root) return;
    clearTimeout(this.timer);
    const normalizedType = ['notice', 'warning', 'error'].includes(type) ? type : 'notice';
    const role = normalizedType === 'error' ? 'alert' : 'status';
    this.root.innerHTML = `<div class="rc5-notice rc5-notice--${normalizedType}" role="${role}">${escapeHtml(message)}</div>`;
    this.timer = setTimeout(() => this.clear(), 5000);
  }
  error(error) { this.show(error?.message || 'Неизвестная ошибка', 'error'); }
  clear() { if (this.root) this.root.textContent = ''; }
  destroy() { clearTimeout(this.timer); this.clear(); this.root = null; }
}
